import React, { useState, useEffect } from "react";
import './header.css'
import { useNavigate, Link } from "react-router-dom";

import { Button } from "react-bootstrap";

export default function HeaderMenu({ children }) {

  const [showMenu, setShowMenu] = useState(false);
  const [menuItemActive, setMenuItemActive] = useState(false);
  const [offPeriod, setOffPeriod] = useState(false);
  const [aboutINB, setAboutINB] = useState(false);
  const [useINB, setUseINB] = useState(false);
  const [resources, setResources] = useState(false);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [isAbout, setIsAbout] = useState(false);
  const [isHow, setIsHow] = useState(false);
  const [savingDrop, setSavingDrop] = useState(false);
  const [tools, setTools] = useState(false);
  const menu = [
    {title: "What Are OFF Periods?", path: "/what-are-off-periods", children: 
      [
        {title: "Return of PD Symptoms", path: "/what-are-off-periods#return-symptoms"},
        {title: "Experiencing OFF Periods", path: "/what-are-off-periods#experiencing-off"},
      ]
    },
    {title: "About INBRIJA", path: "/about-inbrija", children: 
      [
        {title: "What is INBRIJA", path: "/about-inbrija#what-is-inbrija"},
        {title: "Talking With Your Doctor", path: "/about-inbrija#talking-with-doctor"},
      ]
    },
    {title: "INBRIJA Stories", path: "/inbrija-stories", children: []},
    {title: "How to Use INBRIJA", path: "/how-to-use-inbrija", children: 
      [
        {title: "When to Use INBRIJA", path: "/how-to-use-inbrija#when-to-use"},
        {title: "Learn How to Use INBRIJA", path: "/how-to-use-inbrija#learn-how-use-inbrija"},
        {title: "Nurse Educator Support", path: "/how-to-use-inbrija#nurse-educator-support"},
        {title: "Helpful Hints", path: "/how-to-use-inbrija#helpful-hints"},
      ]
    },
    {title: "Savings & Support", path: "/savings-and-support", children: 
      [
        {title: "Savings Programs", path: "/savings-and-support#savings-programs"},
        {title: "Patient Support Services", path: "/savings-and-support#prescription-services"},
      ]
    },
    {title: "Resources", path: "/tools-and-resources", children: 
      [
        {title: "Tools and Resources", path: "/tools-and-resources"},
        {title: "Common Questions", path: "/common-questions"},
        {title: "For People on INBRIJA", path: "/for-people-on-inbrija"},
        {title: "Carepartner Resources", path: "/carepartner-resources"},
      ]
    },
  ]

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Tab' && event.target.id === 'dropdown-off-period') {
        setIsOpen(true);
      }
      if (event.key === 'Tab' && event.target.id === 'dropdown-off-period-close') {
        setIsOpen(false);
      }
      if (event.key === 'Tab' && event.target.id === 'dropdown-about') {
        setIsAbout(true);
      }
      if (event.key === 'Tab' && event.target.id === 'story') {
        setIsAbout(false);
      }
      if (event.key === 'Tab' && event.target.id === 'howto') {
        setIsHow(true);
      }
      if (event.key === 'Tab' && event.target.id === 'howtoclose') {
        setIsHow(false);
      }
      if (event.key === 'Tab' && event.target.id === 'savingopen') {
        setSavingDrop(true)
      }
      if (event.key === 'Tab' && event.target.id === 'savingclose') {
        setSavingDrop(false)
      }
      if (event.key === 'Tab' && event.target.id === 'toolsopen') {
        setTools(true)
      }
      if (event.key === 'Tab' && event.target.id === 'resources_educational_programs') {
        setTools(false)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'dropdown-about') {
        setIsOpen(true)
      }

      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'sign_up_updates') {
        setTools(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'resources_educational_programs') {
        setTools(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'toolsopen') {
        setTools(false)
        setSavingDrop(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'savingclose') {
        setSavingDrop(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'savingopen') {
        setSavingDrop(false)
        setIsHow(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'howtoclose') {
        setIsHow(true);
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'howto') {
        setIsHow(false);
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'drop-stories') {
        setIsAbout(true);
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'story') {
        setIsAbout(true);
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'dropdown-about') {
        setIsAbout(false);
        setIsOpen(true)
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'dropdown-off-period-close') {
        setIsOpen(true);
      }
      if (event.key === 'Tab' && event.shiftKey && event.target.id === 'dropdown-off-period') {
        setIsOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const path = document.location.pathname;

  return (
    <div className="header-menu-container">
      <div>
        <div id="primary-menu-section" className="header-menu-width">

          <div className="header-logo text-left">
            <Link to="/" id="inbrija_logo">
              <img src="/assets/images/inbrija-logo.webp" className="logo" alt="Inbrija logo" />
            </Link>
          </div>

          <div className="menu-section">

            <div className="d-flex flex-row-reverse mt-1 mb-3">
              <Link id="btn-header-muhammad" className="btn border yellow-border-btn px-4" to="/muhammad-ali">Inspired by Ali, Made for the Fighters <img src="/assets/images/arrow-short-right.svg" className="ms-2" /></Link>
            </div>

            <div className="flex-row">
              {/* These are pages that should be crawled by react-snap, but not visible to users */}
              <div className="hidden">
                <a href="/about-inbrija">About</a>
                <a href="/contact-us">Contact Us</a>
                <a href="/common-questions">Common Questions</a>
                <a href="/for-people-on-inbrija">For People on INBRIJA</a>
                <a href="/how-to-use-inbrija">How to Use</a>
                <a href="/inbrija-stories">INBRIJA Stories</a>
                <a href="/pdf-resources">PDF Resources</a>
                <a href="/savings-and-support">Savings and Support</a>
                <a href="/sign-up">Sign Up</a>
                <a href="/sitemap">Sitemap</a>
                <a href="/thank-you">Thank You</a>
                <a href="/tools-and-resources">Tools and Resources</a>
                <a href="/unsubscribe">Unsubscribe</a>
                <a href="/unsubscribe-confirmation">Unsubscribed</a>
                <a href="/what-are-off-periods">What Are OFF Periods?</a>
                <a href="/carepartner-resources">Carepartner Resources</a>
                <a href="/muhammad-ali">Muhammad Ali</a>
              </div>

              <div className="dropdown">
                <Link className={(path.search("what-are-off-periods") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} id="dropdown-off-period" to="/what-are-off-periods">
                  <div className={(path.search("what-are-off-periods") > 0 ) ? "menu fw-bold" : "menu"}> What Are OFF Periods? <img src="/assets/images/dropdown.webp" alt="arrow" /></div>
                </Link>
                <div className="off-period-margin">
                  <div className={`dropdown-menu dropdown-content ${isOpen ? 'open' : ''}`}>
                    <li>
                      <Link to="/what-are-off-periods#return-symptoms">Return of PD Symptoms</Link>
                    </li>
                    <li>
                      <Link to="/what-are-off-periods#experiencing-off" id="dropdown-off-period-close">Experiencing OFF Periods</Link>
                    </li>
                  </div>
                </div>
              </div>

              <div className="dropdown">
                <Link className={(path.search("about-inbrija") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} id="dropdown-about" to="/about-inbrija">
                  <div className={(path.search("about-inbrija") > 0 ) ? "menu fw-bold" : "menu"}>About INBRIJA <img src="/assets/images/dropdown.webp" alt="arrow" /></div>
                </Link>
                <div className="about-inbrija-menu-margin">
                  <div className={`dropdown-menu dropdown-content ${isAbout ? 'open' : ''}`}>
                    <Link to="/about-inbrija#what-is-inbrija">What Is INBRIJA?</Link>
                    <Link to="/about-inbrija#talking-with-doctor" id="story">Talking With Your Doctor</Link>
                  </div>
                </div>
              </div>

              <div className="dropdown">
                <Link className={(path.search("inbrija-stories") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} id="drop-stories" to="/inbrija-stories">
                  <div className={(path.search("inbrija-stories") > 0 ) ? "menu fw-bold" : "menu"}>INBRIJA Stories</div>
                </Link>
              </div>

              <div className="dropdown">
                <Link className={(path.search("how-to-use-inbrija") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} id="howto" to="/how-to-use-inbrija">
                  <div className={(path.search("how-to-use-inbrija") > 0 ) ? "menu fw-bold" : "menu"}>How to Use INBRIJA <img src="/assets/images/dropdown.webp" alt="arrow" /></div>
                </Link>
                <div className="use-inbrija-margin">
                  <div className={`dropdown-menu dropdown-content ${isHow ? 'open' : ''}`}>
                    <Link to="/how-to-use-inbrija#when-to-use">When to Use INBRIJA</Link>
                    <Link to="/how-to-use-inbrija#learn-how-use-inbrija">Learn How to Use INBRIJA</Link>
                    <Link to="/how-to-use-inbrija#nurse-educator-support">Nurse Educator Support</Link>
                    <Link to="/how-to-use-inbrija#helpful-hints" id="howtoclose">Helpful Hints</Link>
                  </div>
                </div>
              </div>

              <div className="dropdown">
                <Link className={(path.search("savings-and-support") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} to="/savings-and-support" id="savingopen">
                  <div className={(path.search("savings-and-support") > 0 ) ? "menu fw-bold" : "menu"} onKeyDown={() => setSavingDrop(false)}>Savings & Support <img src="/assets/images/dropdown.webp" alt="arrow" /></div>
                </Link>
                <div className="saving-support-margin">
                  <div className={`dropdown-menu dropdown-content ${savingDrop ? 'open' : ''}`}>
                    <Link to="/savings-and-support#savings-programs">Savings Programs</Link>
                    <Link to="/savings-and-support#prescription-services" id="savingclose">Patient Support Services</Link>
                  </div>
                </div>
              </div>

              <div className="dropdown">
                <Link className={(path.search("tools-and-resources") > 0 ) ? "active text-decoration-none" : "text-decoration-none"} to="/tools-and-resources" id="toolsopen"> 
                  <div className={(path.search("tools-and-resources") > 0 ) ? "menu fw-bold" : "menu"}>Resources <img src="/assets/images/dropdown.webp" alt="arrow" /></div>
                </Link>
                <div className="resources-margin">
                  <div className={`dropdown-menu dropdown-content ${tools ? 'open' : ''}`}>
                    <Link to="/tools-and-resources">Tools and Resources</Link>
                    <Link to="/common-questions">Common Questions</Link>
                    <Link to="/for-people-on-inbrija">For People on INBRIJA</Link>
                    <Link to="/carepartner-resources">Carepartner Resources</Link>
                  </div>
                </div>
              </div>

              <div className="d-inline-flex">
                <button className="sign-up-button" id="sign_up_updates" onClick={() => navigate('/sign-up')}>Sign Up for Updates</button>
              </div>
            </div>
          </div>
          <div className="collapse-menu">
            {showMenu ?
              <div className="close-container" onClick={() => setShowMenu(false)}>
                <div className="left"></div>
                <div className="right"></div>
              </div>
              : <img src="/assets/images/Menu.webp" alt="menu" className="menu-img" onClick={() => setShowMenu(true)} />}
          </div>
        </div>

        {showMenu &&
          <div className="mobile-menu">
            <div className="mt-1 mb-3">
              <Link id="btn-header-muhammad" className="btn border yellow-border-btn px-4" to="/muhammad-ali">Inspired by Ali, Made for the Fighters <img src="/assets/images/arrow-short-right.svg" className="ms-2" /></Link>
            </div>
            <div className="mobile-saperator mt-4"></div>
            <p onClick={() => setOffPeriod(!offPeriod)} 
              className={(document.location.pathname.search("what-are-off-periods") > 0 ) ? "active" : ""}>
                What Are OFF Periods? {offPeriod ? <img src="/assets/images/drop-close.webp" alt="arrow" className="drop-close" onClick={() => setOffPeriod(false)} /> : <img src="/assets/images/dropdown.webp" alt="arrow" onClick={() => setOffPeriod(true)} />} </p>
            {offPeriod &&
              <div>
                <ul>
                  <li onClick={() => navigate('/what-are-off-periods#return-symptoms')}>Return of PD Symptoms</li>
                  <li onClick={() => navigate('/what-are-off-periods#experiencing-off')} className="mt-015">Experiencing OFF Periods</li>
                </ul>
              </div>}
            <div className="mobile-saperator"></div>
            <p onClick={() => setAboutINB(!aboutINB)} className={(document.location.pathname.search("about-inbrija") > 0 ) ? "active" : ""}>
              About INBRIJA  {aboutINB ? <img src="/assets/images/drop-close.webp" alt="arrow" className="drop-close" onClick={() => setAboutINB(false)} /> : <img src="/assets/images/dropdown.webp" alt="arrow" onClick={() => setAboutINB(true)} />}</p>
            {aboutINB &&
              <div>
                <ul>
                  <li onClick={() => navigate('/about-inbrija#what-is-inbrija')}>What Is INBRIJA?</li>
                  <li className="mt-015" onClick={() => navigate('/about-inbrija#talking-with-doctor')}>Talking With Your Doctor</li>
                </ul>
              </div>}
            <div className="mobile-saperator"></div>
            <p onClick={() => navigate('/inbrija-stories')} className={(document.location.pathname.search("inbrija-stories") > 0 ) ? "active" : ""}>INBRIJA Stories</p>
            <div className="mobile-saperator"></div>
            <p onClick={() => setUseINB(!useINB)}className={(document.location.pathname.search("how-to-use-inbrija") > 0 ) ? "active" : ""}>
              How to Use INBRIJA {useINB ? <img src="/assets/images/drop-close.webp" alt="arrow" className="drop-close" onClick={() => setUseINB(false)} /> : <img src="/assets/images/dropdown.webp" alt="arrow" onClick={() => setUseINB(true)} />}
            </p>
            {useINB &&
              <div>
                <ul>
                  <li onClick={() => navigate('/how-to-use-inbrija#when-to-use')}>When to Use INBRIJA</li>
                  <li onClick={() => navigate('/how-to-use-inbrija#learn-how-use-inbrija')} className="mt-015">Learn How to Use INBRIJA</li>
                  <li onClick={() => navigate('/how-to-use-inbrija#nurse-educator-support')} className="mt-015">Nurse Educator Support</li>
                  <li onClick={() => navigate('/how-to-use-inbrija#helpful-hints')} className="mt-015">Helpful Hints</li>
                </ul>
              </div>}
            <div className="mobile-saperator"></div>
            <p onClick={() => setSaving(!saving)} className={(document.location.pathname.search("savings-and-support") > 0 ) ? "active" : ""}>Savings & Support {saving ? <img src="/assets/images/drop-close.webp" alt="arrow" className="drop-close" onClick={() => setSaving(false)} /> : <img src="/assets/images/dropdown.webp" alt="arrow" onClick={() => setSaving(true)} />}</p>
            {saving &&
              <div>
                <ul>
                  <li onClick={() => navigate('/savings-and-support#savings-programs')}>Savings Programs</li>
                  <li onClick={() => navigate('/savings-and-support#prescription-services')} className="mt-015">Patient Support Services</li>
                </ul>
              </div>}
            <div className="mobile-saperator"></div>
            <p onClick={() => setResources(!resources)} 
            className={((document.location.pathname.search("tools-and-resources") > 0) || (document.location.pathname.search("common-questions") > 0) || (document.location.pathname.search("for-people-on-inbrija") > 0) || (document.location.pathname.search("carepartner-resources") > 0) ) ? "active" : ""}>
              Resources {resources ? <img src="/assets/images/drop-close.webp" alt="arrow" className="drop-close" onClick={() => setResources(false)} /> : <img src="/assets/images/dropdown.webp" alt="arrow" onClick={() => setResources(true)} />}</p>
            {resources &&
              <div>
                <ul>
                  <li onClick={() => navigate('/tools-and-resources')}>Tools and Resources</li>
                  <li onClick={() => navigate('/common-questions')} className="mt-015">Common Questions</li>
                  <li onClick={() => navigate('/for-people-on-inbrija')} className="mt-015">For People on INBRIJA</li>
                  <li onClick={() => navigate('/carepartner-resources')} className="mt-015">Carepartner Resources</li>
                </ul>
              </div>}
            <div className="mobile-saperator"></div>
            <div className="text-left pb-3">
              <a href="https://inbrija-hcp.com"><small className="website-links-mobile">US Healthcare Professionals Website</small></a> <br />
            </div>
            <div className="mobile-saperator"></div>
            <div className="text-center" style={{ marginBottom: '12px' }}>
                <Button variant="dark" className="sign-up-button website-links-mobile rounded-pill px-5 my-3" id="sign_up_update_mobile" onClick={() => navigate('/sign-up')}>Sign Up for Updates</Button>
            </div>
            <small className="website-links-mobile-noborder question">Questions?: <a href="tel:1-833-462-7452" className="question"><span className="text-decortion">1-833-INBRIJA</span></a></small>
          </div>
        }
      </div>
      {children}
    </div>
  )
}